import React from "react";
import styled from "styled-components";
import ContactForm from "../component/sections/ContactForm";
import WhatsupMessageBox from "../component/sections/WhatsupMessageBox";



const Contact = () => {

  return (
    <>
      <h2 className="common-heading">Feel Free to Contact us</h2>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1296.0502649083314!2d75.86888800929374!3d25.160576511304697!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x5db30b45b659b84f!2sKota&#39;s%20online%2Foffline%20home%20tuitions%20for%20cbse%20and%20rbse%20(5%20-%2010)!5e0!3m2!1sen!2sin!4v1668244112684!5m2!1sen!2sin"
        width="100%"
        height="450"
        style={{ border: 0} }
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    {/* <ContactForm /> */}

    +<div>
    <h2 className="common-heading">Lets chat with us</h2>
    <WhatsupMessageBox/>      {/* Whatsup message box */}
    </div>
    </>
  );
};

export default Contact;
